export default "__VITE_ASSET__DJWYW$oi__"